/**
 * Problem types.
 **/
export const ProblemTypes = {
  OUT_OF_STOCK: "errors/inventory/out-of-stock"
};
